import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-29915ef0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
const _hoisted_2 = ["innerHTML"];
import { ref, onMounted } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'sticky_bullet_point_list',
    props: ['d'],
    setup(__props) {
        const bulletPoints = ref([]);
        const indexActive = ref(0);
        onMounted(() => {
            const options = {
                root: null,
                rootMargin: "-50% 0% -50% 0%",
                threshold: 0
            };
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    const index = bulletPoints.value.indexOf(entry.target);
                    if (entry.isIntersecting) {
                        indexActive.value = index;
                    }
                });
            }, options);
            bulletPoints.value.forEach(point => {
                observer.observe(point);
            });
        });
        // Check if the device is mobile based on screen width
        const isMobile = ref(window.innerWidth <= 992);
        // Update isMobile value when the window size changes
        window.addEventListener('resize', () => {
            isMobile.value = window.innerWidth <= 992;
        });
        function isActive(index) {
            return indexActive.value === index;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "sticky_bullet_point_list",
                style: _normalizeStyle(`background-color: ${__props.d.background_colour ? __props.d.background_colour : '#fff'}`)
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.sticky_bullet_point_list, (item, index) => {
                        return (_openBlock(), _createElementBlock("h3", {
                            class: _normalizeClass(["sticky_bullet_point_list__item", { 'sticky_bullet_point_list__item--active': isActive(index), 'sticky_bullet_point_list__item--mobile': isMobile.value }]),
                            key: index,
                            ref_for: true,
                            ref_key: "bulletPoints",
                            ref: bulletPoints,
                            innerHTML: item.title
                        }, null, 10, _hoisted_2));
                    }), 128))
                ])
            ], 4));
        };
    }
});
